import { type NextPage } from 'next';

import { OpenModalButton } from '@admin/molecules/OpenModalButton';
import { type IndexPageProps } from '@admin/pages';
import { useTranslation } from '@cms/i18n/client';
import { BaseModalProvider, BaseModalType } from '@common/organisms/BaseModal';

import { CreateModal } from './articles/organisms/CreateModal';

export interface State {
    dataIsOutdated: boolean;
}

export const IndexPage: NextPage<IndexPageProps> = ({ categories }) => {
    const __translate = useTranslation('common').t;

    return (
        <BaseModalProvider>
            <div className="deprecated-container">
                <h2>{__translate('title.claimbox')}</h2>
                <OpenModalButton variant="filled-success" contextKey={BaseModalType.Create}>
                    {__translate('title.new')}
                </OpenModalButton>
                <CreateModal categories={categories} __namespace={'articles'} />
            </div>
        </BaseModalProvider>
    );
};
